export const normalizeLinkedTicketUrl = (rawUrl: string): string => {
  const trimmed = rawUrl.trim()
  if (!trimmed) return ''
  try {
    const parsed = new URL(trimmed)
    const host = parsed.hostname.trim().toLowerCase()
    const isJiraBrowsePath = /^\/browse\/[^/]+$/i.test(parsed.pathname)
    const hasNoDomain = host !== '' && !host.includes('.')
    if (isJiraBrowsePath && hasNoDomain) {
      parsed.hostname = `${host}.atlassian.net`
      return parsed.toString()
    }
    return trimmed
  } catch {
    return trimmed
  }
}
